import * as React from 'react';
import { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  FormHelperText,
  Box,
  Paper,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { printVariable } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import useDelegate from "@hooks/useDelegate";
import { styled } from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import ConfirmDialog from "@components/ConfirmDialog";
import Tab from "@mui/material/Tab"
import TabList from "@mui/lab/TabList"
import TabContext from "@mui/lab/TabContext"
import TabPanel from "@mui/lab/TabPanel"
import Autocomplete from "@mui/material/Autocomplete"
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import { takeRight } from 'lodash';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

const filterOptions = (options, state) => {
  let newOptions = []
  newOptions = options.filter((o) => o.name.includes(state.inputValue)).slice(0, 10)
  return newOptions
}

const dateFormat = 'YYYY-MM-DD HH:mm:ss';
const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;


import { hashids } from '@util/helper'
const topicMenuSchool = [
  { name: '전체 관계자', value: 'TP01' },
  { name: '전체 학생 보호자', value: 'TP04' },
  { name: '전체 강사', value: 'TP05' },
  { name: '강좌 관련자', value: 'TP06' },
  { name: '특정수업일(출석부상) 관련자', value: 'TP07' },
  { name: '개별학생 보호자', value: 'TP08' },
  { name: '학년', value: 'TP09' },
  { name: '전체 수강생 보호자', value: 'TP11' },
  { name: '바우처 알림', value: 'TP12' },
]

const topicMenuCompany = [
  { name: '전체 관계자', value: 'TP100' },
  { name: '전체 매니저', value: 'TP101' },
  { name: '전체 강사', value: 'TP102' },
]

const ManagerVoucherPartPost = ({ dialogHandler, record, msgType, topic, tid, callback }) => {

  // redux
  const account = useSelector(state => state.accountReducer);
  const codes = useSelector(state => state.codeReducer)
  const schola = useSelector(state => state.scholaReducer);
  const [topicMenu, set_topicMenu] = useState(topicMenuSchool)
  const [title, set_title] = useState(record.name)
  const [content, set_content] = useState(record.content)

  const [targetTopic, set_targetTopic] = useState(topic ?? '')
  const [targetStudents, set_targetStudents] = useState([])
  const [targetDate, set_targetDate] = useState(null)
  const [targetLectures, set_targetLectures] = useState([])
  const [targetLectureId, set_targetLectureId] = useState()
  const studentListRef = React.useRef([])
  const [allChecked, set_allChecked] = useState(true)
  const [hasWalletChecked, set_hasWalletChecked] = useState(false)
  const [noWalletChecked, set_noWalletChecked] = useState(false)
  const [students, set_students] = useState([])
  const encSurveyId = hashids.encode(record.id)
  const [data, set_data] = useState({
    topicMenu: topicMenu[0].value,
    lectureId: 0,
    title: '',
    content: '',
  })
  const [grades, set_grades] = useState([
    { grade: 1, label: '1학년', isChecked: false },
    { grade: 2, label: '2학년', isChecked: false },
    { grade: 3, label: '3학년', isChecked: false },
    { grade: 4, label: '4학년', isChecked: false },
    { grade: 5, label: '5학년', isChecked: false },
    { grade: 6, label: '6학년', isChecked: false },
  ]);

  // const msgTitle = msgType === 'push' ?  '푸시 메시지 전송' : '문자 메시지 전송'
  const msgTitle = `[${record.name}] 바우처 푸시 알림`
  const [confirmMsg, set_confirmMsg] = useState('메시지를 발송하시겠습니까?')

  const [tabValue, set_tabValue] = useState('1')
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()

  const [smst, set_smst] = useState({})
  const [smstList, set_smstList] = useState([])
  const [lectures, set_lectures] = useState([])
  const catCodes = codes.filter(r => r.codeGroupId === 'SA32')
  // const [students, set_students] = useState([])
  const studentsRef = React.useRef([])
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
      if (callback) {
        callback()
      }
    }
  }

  const fetchVoucherInfo = async () => {
    const url = `/voucher/info/${record.id}/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const data = JSON.parse(repMessage.voucherInfo)
    const students = data.students

    const walletsByStudent = {}

    data.wallets.forEach(w => {
      // 학생별 월렛 목록
      if (!walletsByStudent[w.studentId]) walletsByStudent[w.studentId] = []
      walletsByStudent[w.studentId].push(w)
    })

    students.forEach(s => {
      s.label = `${s.name}(${s.grade}학년, ${s.className}반, ${s.classNum}번)`
      s.checked = true
      s.hasWallet = walletsByStudent[s.id]?.length > 0
    })

    set_students(students)
  }


  const searchStudent = async (word) => {
    // 4 byte check
    const regex = /[\uAC00-\uD7AF]+/g

    if (!regex.test(word)) {
      return []
    }

    const url = `/student/school/name/${schola.id}/${word}`
    const resp = await WebService.get(url)
    if (resp.repCode !== "ack") {
      openSnackbar(resp.repMessage)
      return []
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    for (const record of records) {
      // record.label = `${record.name}(${record.gdnPhone})`
      record.label = `${record.name}(${record.grade}학년, ${record.className}반, ${record.classNum}번)`
    }
    return records
  }



  const fetchLectures = async (smstIdList) => {
    const url = `/lecture/smstids`
    openIndicator()
    const resp = await WebService.post(url, smstIdList)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const onLoad = async () => {
    await fetchVoucherInfo()
  }

  const validate = () => {
    if (!targetTopic) {
      alert('수신 그룹이 선택되지 않았습니다.')
      return
    }
    if (targetTopic === 'TP06') {
      if (!targetLectureId) {
        alert('강좌가 선택되지 않았습니다.')
        return
      }
    }
    if (targetTopic === 'TP07') {
      if (!targetDate) {
        alert('수업일이 선택되지 않았습니다.')
        return
      }
      if (targetLectures.length === 0) {
        alert('선택한 수업일에 출석부 생성된 강좌가 없습니다.')
        return
      }
    }
    if (targetTopic === 'TP08') {
      if (targetStudents.length === 0) {
        alert('메시지를 발송할 대상(학생보호자)가 없습니다.')
        return
      }
    }

    if (targetTopic === 'TP09') {
      if (grades.filter(r => r.isChecked).length === 0) {
        alert('학년이 선택되지 않았습니다.')
        return
      }
    }

    if (targetTopic === 'TP11') {
      if (smstList.length == 0) {
        alert('메시지를 발송할 수 있는 학기가 없습니다.')
        return
      }
      if (smstList.filter(r => r.isChecked).length === 0) {
        alert('선택된 학기가 없습니다.')
        return
      }
    }

    if (targetTopic === 'TP12') {
      if (targetStudents.length === 0) {
        alert('메시지 발송할 학생이 선택되지 않았습니다.')
        return
      }
    }

    if (!title) {
      alert('제목이 비어 있습니다.')
      return
    }
    if (!content) {
      alert('내용이 비어 있습니다.')
      return
    }
    return true
  }

  const fetchLecturesOfDate = async (date) => {
    const url = `/lecture/date/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url, {
      date: date
    })
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const lectures = JSON.parse(repMessage.records)
    return lectures
  }

  const canSubmit = async () => {
    const validated = validate()
    if (validated) {
      if (msgType === 'sms') {
        await preSubmit()
      }
      return true
    }

    return false
  }

  const onChangeTargetDate = async (date) => {
    set_targetDate(date)
    const targetLectures = await fetchLecturesOfDate(date)
    set_targetLectures(targetLectures)
  }

  const preSubmit = async () => {
    const topicCode = targetTopic
    const url = encodeURI(`/sms/pre/fetch/${schola.id}/${topicCode}`)

    const tdate = targetDate.length >= 10 ? targetDate.substring(0, 10) : ''
    const params = {
      lectureId: targetLectureId,
      targetDate: tdate
    }
    const studentIds = targetStudents.map(r => r.id)
    const data = {
      title: title,
      content: content,
      studentIds: studentIds
    }

    openIndicator()
    const resp = await WebService.post(url, data, params)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    set_confirmMsg(`${repMessage.confirm}\n메시지를 발송하시겠습니까?`)
  }


  const onSubmit = async () => {

    const topicCode = targetTopic
    const pushUrl = encodeURI(`/topic/${schola.id}/${topicCode}`)
    const smsUrl = encodeURI(`/sms/${schola.id}/${topicCode}`)
    const url = msgType === 'push' ? pushUrl : smsUrl

    const params = {
      voucherId: record.id,
    }

    const studentIds = targetStudents.map(r => r.id)
    console.log('studentIds=>', studentIds)
    const targetGrades = grades.filter(r => r.isChecked).map(r => r.grade)
    const targetSmstIds = smstList.filter(r => r.isChecked).map(r => r.id)
    const data = {
      title: title,
      content: content,
      studentIds: studentIds,
      grades: targetGrades,
      smstIds: targetSmstIds,
    }

    openIndicator()
    const resp = await WebService.post(url, data, params)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    alert('전송하였습니다.')

    callback()
  }

  const onChangeGroup = (e) => {
    // set_targetTopic(e.target.value)
    // set_targetStudents([])
    // set_targetDate('')
    // set_targetLectures([])
  }

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }

  useEffect(() => {
    if (dialogHandler[0]) {
      onLoad()
    }
  }, [dialogHandler[0]])


  useEffect(() => {
    console.log("리스트 컨테이너가 마운트(생성)되었습니다.");
  }, [])

  useEffect(() => {
    if (tabValue === '1') {
      set_topicMenu(topicMenuSchool)
    }

    if (tabValue === '2') {
      set_topicMenu(topicMenuCompany)
    }

    // set_targetTopic('')

  }, [tabValue])


  useEffect(() => {
    set_targetStudents([])
    set_targetLectureId('')
    set_targetDate('')
    const newGrades = grades.map(r => ({ ...r, isChecked: false }))
    set_grades(newGrades)
    if (targetTopic === 'TP06') {
      if (tid) {
        set_targetLectureId(tid)
      }
    }
  }, [targetTopic])

  useEffect(() => {
    if (record.catCode === 'V001') {
      set_content(`안녕하십니까. 방과후 지원실에서 귀 자녀의 초등학교 방과후 지원금(바우처) 안내를 아래와 같이 드리오니 이용에 참고하여 주시기 바랍니다.`)
    }
  }, [])

  useEffect(() => {
    const ss = []
    students.forEach(s => {
      if (s.checked) {
        ss.push(s)
      }
    })
    set_targetStudents(ss)
  }, [students])

  const Body = () => {

    const onChangeGroup = (e) => {
      // set_targetTopic(e.target.value)
      // set_targetStudents([])
      // set_targetDate('')
      // set_targetLectures([])
    }

    useEffect(() => {
      console.log('Body recreated...')
    }, [])

    return (
      <></>
    )
  }


  return (
    <Fragment>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg' fullWidth disableAutoFocus disableRestoreFocus enforceFocus={false}>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            {msgTitle}
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} >
            <Grid item xs={6}>  {/* Left */}
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <Box sx={{ width: "100%", typography: "body1" }}>
                    <TabContext value={tabValue}>
                      <Box sx={{ borderBottom: 1, borderColor: "divider", position: "sticky", top: 0, backgroundColor: "#fff" }}>
                        <TabList onChange={handleTabChange} aria-label='lab API tabs example'>
                          <Tab label='교내 메시지' value='1' />
                          {/* <Tab label='사내 메시지' value='2' /> */}
                        </TabList>
                      </Box>
                      <TabPanel value='1' >
                        <Grid container spacing={1}>
                          <Grid item xs={12}>
                            <FormControl fullWidth>
                              <InputLabel id='topicMenu'>
                                수신그룹
                              </InputLabel>
                              <Select
                                disabled
                                labelId='topicMenu'
                                required
                                label='수신그룹'
                                value={targetTopic}
                                onChange={async (e) => {
                                  onChangeGroup(e)
                                }}>
                                {
                                  topicMenu.map((l, index) => (
                                    <MenuItem key={index} value={l.value}>
                                      {l.name}
                                    </MenuItem>
                                  ))
                                }
                              </Select>
                            </FormControl>
                          </Grid>

                          {
                            targetTopic === 'TP12' &&  record.catCode === 'V001' ? (
                              <>
                                <Grid item xs={12} style={{ marginTop: 10 }}>
                                  <FormControl fullWidth>
                                    <InputLabel id='lecture'>
                                      분류코드
                                    </InputLabel>
                                    <Select
                                      labelId='topicMenu'
                                      disabled
                                      required
                                      label='강좌'
                                      value={record.catCode}
                                      onChange={async (e) => {
                                        set_targetLectureId(e.target.value)
                                      }}>
                                      {catCodes.map((code, index) => {
                                        return (
                                          <MenuItem key={index} value={code.code}>
                                            {code.name}
                                          </MenuItem>
                                        )
                                      })}
                                    </Select>
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                  <Grid container>
                                    <Grid item xs={4}>
                                      <FormControlLabel control={
                                        <Checkbox
                                          checked={allChecked}
                                          onChange={(e) => {
                                            set_allChecked(e.target.checked)
                                            const new_students = [...students]
                                            new_students.forEach((s) => {
                                              s.checked = e.target.checked
                                            })
                                            set_students(new_students)

                                            set_hasWalletChecked(false)
                                            set_noWalletChecked(false)

                                          }}
                                        />
                                      } label="전체 선택" />
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControlLabel control={
                                        <Checkbox
                                          checked={hasWalletChecked}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              const new_students = [...students]
                                              new_students.forEach((s) => {
                                                s.checked = s.hasWallet
                                              })
                                              set_students(new_students)

                                              set_hasWalletChecked(true)
                                              set_allChecked(false)
                                              set_noWalletChecked(false)
                                            }
                                          }}
                                        />
                                      } label="수강생만 선택" />
                                    </Grid>
                                    <Grid item xs={4}>
                                      <FormControlLabel control={
                                        <Checkbox
                                          checked={noWalletChecked}
                                          onChange={(e) => {
                                            if (e.target.checked) {
                                              const new_students = [...students]
                                              new_students.forEach((s) => {
                                                s.checked = !s.hasWallet
                                              })

                                              set_students(new_students)

                                              set_noWalletChecked(true)
                                              set_allChecked(false)
                                              set_hasWalletChecked(false)
                                            }
                                          }}
                                        />
                                      } label="비수강생만 선택" />

                                    </Grid>
                                  </Grid>

                                </Grid>
                                <Grid item xs={12}  >
                                  <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography>발송 대상: {targetStudents.length} </Typography>
                                </Grid>
                                <Grid item xs={12}  >
                                  <Divider />
                                </Grid>
                                <Grid item xs={12}  >
                                  <div style={{ height: 500, backgroundColor: '#fafafa', overflow: 'auto', padding: 10 }}>

                                    {students?.map((s, idx) => (
                                      <div key={`stid-${s.id}`} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                                        <div style={{ marginRight: 5 }}>
                                          <input
                                            type="checkbox"
                                            id={`chk-student-${s.id}`}
                                            checked={s.checked}
                                            onChange={(e) => {
                                              const new_students = [...students]
                                              new_students[idx].checked = e.target.checked
                                              const checkedStudents = new_students.filter((r) => r.checked)
                                              set_students(new_students)

                                              if (checkedStudents.length === students.length) {
                                                set_allChecked(true)
                                              }
                                              else {
                                                set_allChecked(false)
                                              }

                                              set_hasWalletChecked(false)
                                              set_noWalletChecked(false)
                                            }}
                                          />
                                          <label htmlFor={`chk-student-${s.id}`} style={{ cursor: 'pointer' }}>
                                            {s.label}
                                          </label>
                                        </div>
                                        {/* <div style={{ marginRight: 5 }}>{s.label}</div> */}
                                      </div>
                                    ))}
                                  </div>
                                </Grid>
                                <Grid item xs={12}>
                                  <Divider />
                                </Grid>
                                
                              </>
                            ) : null
                          }

                        </Grid>
                      </TabPanel>
                      {/* <TabPanel value='2' > */}
                      {/*   <Body /> */}
                      {/* </TabPanel> */}
                    </TabContext>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6}> {/* Right */}
              <br />
              <Grid container spacing={2}>

                <Grid item xs={12}>
                  <TextField
                    label={'제목'}
                    fullWidth
                    name={'title'}
                    value={title}
                    onChange={e => set_title(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label={'내용'}
                    fullWidth
                    multiline
                    rows={5}
                    name={'content'}
                    value={content}
                    onChange={e => set_content(e.target.value)}
                    InputLabelProps={{
                      // semesterName에 값이 있으면 라벨을 위로 올림
                      shrink: true
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ backgroundColor: '#eeeeee', p: 1, }}>
                    {
                      record.catCode === 'V001' ? (
                        <>
                          <Typography>구분: 초등학교 3학년 방과후 지원금</Typography>
                          <Typography>사용처: {schola.name} </Typography>
                          <Typography>대상: 0학년 0반 0번 김00</Typography>
                          <Typography>바우처 금액: 000,000 원</Typography>
                          <Typography>사용 금액: 000,000 원</Typography>
                          <Typography>잔액: 000,000 원</Typography>
                          <Typography>징수 금액: 000,000 원</Typography>
                        </>
                      ) : (
                        <Typography>알 수 없는 바우처 분류코드 입니다.</Typography>
                      )
                    }

                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2'>
                    학생 보호자에게 저장되어 있는 바우처 정보를 바탕으로 위와 같은 형식의 바우처 내역 알림이 개별적으로 발송됩니다.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button onClick={handleClose}>
            닫기
          </Button>
          <ConfirmDialog
            btn={<Button variant='contained' color={'primary'}>전송</Button>}
            title={'알림'}
            content={confirmMsg}
            bc={'primary'}
            preHandle={async () => {
              return canSubmit()
            }}
            perform={() => {
              onSubmit()
            }}
          />

        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default ManagerVoucherPartPost
